var Event = /** @class */function () {
  function Event(eventValue, eventXValue, data) {
    this.eventValue = eventValue;
    this.eventXValue = eventXValue;
    this.data = data;
    // whitch actor positions to switch
    this.switch = [];
    this.isHidden = false;
    this.add = [];
    this.remove = [];
    this.group = [];
    this.state = [];
    this.hiddenActors = [];
  }
  return Event;
}();
export { Event };
var Actor = /** @class */function () {
  function Actor(actorID, data) {
    this.actorID = actorID;
    this.data = data;
    this.isHidden = false;
    this.layers = [];
  }
  return Actor;
}();
export { Actor };
var RenderedPoint = /** @class */function () {
  function RenderedPoint(x, y, z, isGrouped, strokeWidth, strokeColor, eventValue, eventDescription, url, eventUrl, isHighlighted, actor, event) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.isGrouped = isGrouped;
    this.strokeWidth = strokeWidth;
    this.strokeColor = strokeColor;
    this.eventValue = eventValue;
    this.eventDescription = eventDescription;
    this.url = url;
    this.eventUrl = eventUrl;
    this.isHighlighted = isHighlighted;
    this.actor = actor;
    this.event = event;
    this.hiddenActors = [];
  }
  return RenderedPoint;
}();
export { RenderedPoint };